import classNames from 'classnames';
import { string } from 'prop-types';
import React from 'react';
import { useConfiguration } from '../../../context/configurationContext';
import { isListingUnlisted } from '../../../domain/listingVisibility';
import { ensureListing } from '../../../util/data';
import { injectIntl, intlShape } from '../../../util/reactIntl';
import { getCategoryLabel } from '../../../util/soulwise-marketplace/categories';
import {
  LISTING_FIELD_MODE,
  LISTING_FIELDS,
  getModeLabel as getModeLabelFromConfig,
} from '../../../util/soulwise-marketplace/listingFields';
import {
  isDigitalProductListingType,
  isGroupSession,
} from '../../../util/soulwise-marketplace/listingType';
import { propTypes } from '../../../util/types';
import css from './ListingTags.module.css';
import Tag from './Tag';

const ListingTags = ({ listing, className, intl }) => {
  const classes = classNames(css.tags, className);
  const config = useConfiguration();
  const currentListing = ensureListing(listing);
  const { publicData } = currentListing.attributes;
  const { listingType, categoryLevel1, mode } = publicData || {};

  const isGroupListingType = isGroupSession(listingType);
  const isDigitalListing = isDigitalProductListingType(listingType);
  const isOnlineMode = mode === LISTING_FIELD_MODE.online;
  const isUnlisted = isListingUnlisted(currentListing);

  const modeLabel = getModeLabelFromConfig(mode, config, intl);

  const LISTING_TYPE_LABELS = {
    groupSession: intl.formatMessage({
      id: 'ListingTags.groupSession',
    }),
    individualSession: intl.formatMessage({
      id: 'ListingTags.individualSession',
    }),
  };
  const listingTypeLabel = isGroupListingType
    ? LISTING_TYPE_LABELS.groupSession
    : LISTING_TYPE_LABELS.individualSession;

  const categoryLabel = getCategoryLabel(categoryLevel1, config, intl);

  const contentTagLabel = intl.formatMessage({ id: 'ListingTags.content' });
  const privateLinkOnlyLabel = intl.formatMessage({ id: 'ListingTags.privateLinkOnly' });

  if (isDigitalListing) {
    return (
      <div className={classes}>
        {isUnlisted && <Tag label={privateLinkOnlyLabel} variant="white" />}
        <Tag label={categoryLabel} variant="blue" />
        <Tag label={contentTagLabel} />
      </div>
    );
  }

  return (
    <div className={classes}>
      {isOnlineMode && <Tag label={modeLabel} variant="white" />}
      {isUnlisted && <Tag label={privateLinkOnlyLabel} variant="white" />}
      <Tag label={categoryLabel} variant="blue" />
      <Tag label={listingTypeLabel} />
    </div>
  );
};

ListingTags.propTypes = {
  listing: propTypes.listing.isRequired,
  className: string,
  intl: intlShape.isRequired,
};

export default injectIntl(ListingTags);
